import { Pipe, PipeTransform } from "@angular/core";
import { EditArt } from "../_interfaces/EditArt";
import { TicketEditService } from "../_provider/ticket-edit.service";

@Pipe({
    name: "TicketArt",
    standalone: false
})
export class TicketArtPipe implements PipeTransform{

    constructor(
        private ticketEditService: TicketEditService
    ){}

    transform(id: number): EditArt {
        if(this.ticketEditService.ticketArts.length == 0) return null;
        return this.ticketEditService.ticketArts.find((art: EditArt) => {
            return art.id == id
        })
    }

}